import { Authenticator, AuthenticatorType } from '../types';

import { getAuthToken, getTokenCacheTimeToLive } from './getAuthToken';

// This YammerCache type is duplicated. Importing from yammer-data or yammer-web-support would cause a circular dependency.
// The compromise was to duplicate this type as it's simple and unlikely to change.
export type GetAuthTokenCache = () => YammerCache | undefined;
interface YammerCache {
  getItem<T>(key: string): T | null;
  setItem<T>(key: string, value: T, ttlInSeconds?: number): void;
  removeItem(key: string): void;
  clear(): void;
}

export default class TeamsAuthenticator implements Authenticator {
  public readonly type: AuthenticatorType = AuthenticatorType.Teams;
  protected readonly authTokenCache: YammerCache | undefined;

  constructor(getAuthTokenCache: GetAuthTokenCache) {
    this.authTokenCache = getAuthTokenCache();
  }

  public acquireToken = async ([resource]: string[], claims?: string): Promise<string> => {
    if (!claims) {
      const cachedToken = this.getTokenFromCache(resource);
      if (cachedToken) {
        return cachedToken;
      }
    }

    const token = await this.getToken(resource, claims ? [claims] : undefined);
    this.addTokenToCache(resource, token);

    return token;
  };

  public getToken = (resource: string, claims?: string[]): Promise<string> => getAuthToken(resource, claims);

  public addTokenToCache = (resource: string, token: string): void => {
    const ttl = getTokenCacheTimeToLive(token);
    if (ttl && this.authTokenCache) {
      this.authTokenCache.setItem(resource, token, ttl);
    }
  };

  public getTokenFromCache = (resource: string): string | null => {
    if (this.authTokenCache) {
      return this.authTokenCache.getItem<string>(resource);
    }

    return null;
  };

  public acquireTokenRedirect() {
    throw new Error('acquireTokenRedirect is not implemented');
  }

  public setThirdPartyCookieErrorCallback() {
    throw new Error('setThirdPartyCookieErrorCallback is not implemented');
  }
}
